export default __webpack_public_path__ + "static/media/the-robot-overlord-one.d284dc95.png";